import { Badge, FileIcon, Icon, IconButton } from "components";
import { downloadMedia, mimeType, sortHashtags } from "helpers";
import { useClickAndView } from "hooks";
import { useMemo } from "react";
import { File } from "types";
type Props = {
  file: File.Item;
};

export default function FileCard({ file }: Props) {
  // const [axios, loading] = useAxios();
  const [clickAndView] = useClickAndView({
    contentId: file.id,
    variant: "file",
  });
  const fileType = useMemo(() => {
    return mimeType(file.media?.thumbnailUrl)?.toLowerCase();
  }, [file.media?.thumbnailUrl]);
  const handleClick = () => {
    clickAndView();
    const url = file.media?.url;
    if (!url) return;
    downloadMedia(file.media, file.title);
  };
  return (
    <article className="w-full">
      <div className="flex items-center gap-2.5 py-2.5">
        {/* <Image className="block size-12 rounded" /> */}
        <div className="size-12 rounded bg-[#EFF2F5] flex items-center justify-center [&>*]:w-8">
          {/* <Icon name="More" variant="Bold" className="text-gray-500 size-6" /> */}
          <FileIcon name={fileType as any} />
        </div>
        <div className="flex-1 space-y-1">
          <h3 className="w-full text-base text-[#353740] font-medium">
            {file.title}
          </h3>
          <p className="w-full text-sm text-[#5E6278] font-medium uppercase">
            {fileType}
          </p>
        </div>
      </div>
      <p className="w-full text-sm text-[#5E6278] whitespace-pre-wrap font-normal p-1">
        {file.description}
      </p>
      <div className="flex flex-wrap items-center gap-1 pt-1 pb-2.5">
        {sortHashtags(file.hashTags)?.map((e) => (
          <Badge key={e}>#{e}</Badge>
        ))}
      </div>
      <IconButton
        type="button"
        variant="outline"
        className="flex rounded py-1 px-6 text-[#5E6278] border-[#ECEFF2] ms-auto"
        onClick={handleClick}
        // loading={loading}
      >
        <Icon name="ExportCurve" variant="Linear" />
      </IconButton>
    </article>
  );
}
